import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ValidateNested, Validate, IsOptional } from 'class-validator';
import { ModelBoardFloorCreateDto } from '../../model-board-floor/dto/model-board-floor-create.dto';
import { ModelBoardPurchaseReplaceableInterface } from '../interfaces/model-board-purchase-replaceable.interface';
import { ModelBoardFloorUniqueValidator } from '../../model-board-floor/validators/model-board-floor-unique.validator';

export class ModelBoardPurchaseReplaceDto
  implements ModelBoardPurchaseReplaceableInterface
{
  @ApiPropertyOptional({
    type: () => [ModelBoardFloorCreateDto],
    title: 'Associated Board Floors',
    description: 'The board floors associated with this model',
  })
  @Expose()
  @Type(() => ModelBoardFloorCreateDto)
  @IsOptional()
  @Validate(ModelBoardFloorUniqueValidator)
  @ValidateNested({ each: true })
  modelBoardFloors?: ModelBoardFloorCreateDto[];
}
